module.exports = __webpack_public_path__ + "img/badge_amazon_libri.bf8a5281.jpg";